/**
 * 店长导航
 */
export default () => ({
  STOREMANAGE: {
    component: () => import(
      /* webpackChunkName: 'reportCenter' */
      'allpages/reportCenter/managerNav/index.vue' // 店长导航
    ),
  },
});
